module.exports = __webpack_public_path__ + "img/edit.c78a67de.svg";